import { render, staticRenderFns } from "./BillPromissoryPrint.vue?vue&type=template&id=2d72a037&scoped=true"
import script from "./BillPromissoryPrint.vue?vue&type=script&lang=js"
export * from "./BillPromissoryPrint.vue?vue&type=script&lang=js"
import style0 from "./BillPromissoryPrint.vue?vue&type=style&index=0&id=2d72a037&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d72a037",
  null
  
)

export default component.exports